(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-search"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const shop = window.Shopify.country

    if (shop === 'CH') {
      document.querySelector('.search-blog').style.display = 'none'
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-banner-video"] && !window.DesignMode) return;
  try {
    
(function () {
  const get_video_sections = document.querySelectorAll('.ak_content-video');
  get_video_sections.forEach((el) => { 
    let btn = el.querySelector('.ak-video-play-btn') 
    let ovl = el.querySelector('.ak_bnr--overlay') 
    let vid = el.querySelector('video') 

    // video play/pause
    el.addEventListener('click', (e) => { 
      if (vid.paused) {
        vid.play();
        /*
        if(btn) {elementFader(btn,1,'ovl-btn-hide')}
        if(ovl) {elementFader(ovl,1,'ovl-fade')}
        */
        if(btn) {btn.classList.add('ovl-btn-hide')}
        if(ovl) {ovl.classList.add('ovl-fade')}
      } else {
        vid.pause();
        if(btn) {btn.classList.remove('ovl-btn-hide')}
        if(ovl) {ovl.classList.remove('ovl-fade')}
      }
      e.preventDefault();
    })

    vid.onended = function() {
      this.load();
      if(btn) {btn.classList.remove('ovl-btn-hide')}
      if(ovl) {ovl.classList.remove('ovl-fade')}
    }

    el.addEventListener('mouseover', () => {    
      if(btn) {btn.classList.add('ovl-btn-fade')}
      if(ovl) {ovl.classList.add('ovl-fade')}
    });

    el.addEventListener('mouseout', () => {
      if(btn) {btn.classList.remove('ovl-btn-fade')}
      if(ovl && vid.paused) {ovl.classList.remove('ovl-fade')}
    });
  })
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp_accordion"] && !window.DesignMode) return;
  try {
    
const acc = document.querySelectorAll('.lp-accordion--btn');

acc.forEach(function(item, e) { 
  item.addEventListener("click", function() {  

    if(item.classList.contains('lp-accordion--active')) {
      item.classList.remove('lp-accordion--active')
      item.nextElementSibling.style.maxHeight = null;
      item.setAttribute('aria-expanded', 'false')
    } else {
      for(let i=0; i<acc.length; i++) {
        if( acc[i].classList.contains('lp-accordion--active') ) {
          acc[i].classList.remove('lp-accordion--active')
          acc[i].nextElementSibling.style.maxHeight = null;
          break;
        }
      }
      item.classList.add('lp-accordion--active')
      item.nextElementSibling.style.maxHeight = item.nextElementSibling.scrollHeight+20+"px";
      item.setAttribute('aria-expanded', 'true')
    }

  })
});

  } catch(e) { console.error(e); }
})();
})();
